import React from 'react';

import OrganizationSmall from './Small';
import OrganizationLarge from './Large';

import './style.scss';

const Organization = ({ viewMode, ...props }) => {
  switch (viewMode) {
    case 'small':
      return <OrganizationSmall {...props} />;
    default:
      return <OrganizationLarge {...props} />;
  }

};

export default Organization;
